module.exports = __webpack_public_path__ + "img/seven3Blue.f6523a0f.jpg";